module.exports = __webpack_public_path__ + "img/19.7e01c44a.jpg";